export const USER_SHOW_CREATE_MODAL = "USER_SHOW_CREATE_MODAL";
export const USER_SHOW_EDIT_MODAL = "USER_SHOW_EDIT_MODAL";
export const USER_DELETED = "USER_DELETED";
export const USER_HIDE_CREATE_OR_EDIT_MODAL = "USER_HIDE_CREATE_OR_EDIT_MODAL";
